import React from 'react';
import SolutionInstallmentExaminationConfirmContainer from 'containers/SolutionInstallmentExaminationConfirmContainer/SolutionInstallmentExaminationConfirmContainer';

export default function SolutionInstallmentExaminationConfirmPage() {
    return (
        <SolutionInstallmentExaminationConfirmContainer />
    )
}
